import type { ThemeTypes } from '@common/types/theme/ThemeType';

// PROPOSITION 1 - Classique institutionnelle
const ULAVAL_RED_THEME: ThemeTypes = {
    name: 'RED_THEME',
    dark: false,
    variables: {
        'border-color': '#DCDCDC'
    },
    colors: {
        important: '#E30513',
        primary: '#E30513',
        secondary: '#FFC103',
        info: '#0099FF',
        success: '#51A27E',
        accent: '#F7A941',
        warning: '#FFE081',
        error: '#E30513',

        lightprimary: '#F2828A',
        lightsecondary: '#FFF3CC',
        lightsuccess: '#DCECE5',
        lighterror: '#FCE5E7',
        lightwarning: '#FFF9E5',
        lightinfo: '#E5F5FF',

        textPrimary: '#282828',
        textSecondary: '#FFFFFF',
        borderColor: '#DCDCDC',
        inputBorder: '#B2B2B2',
        containerBg: '#FFFFFF',
        background: '#F2FAFF',
        hoverColor: '#FCE5E7',
        surface: '#FFFFFF',
        'on-surface-variant': '#515151',

        grey100: '#EDEDED',
        grey200: '#DCDCDC',

        buttonHover: '#FCE5E7',
        buttonHoverText: '#AA030E',
        buttonSecondaryHover: '#E30513',
        buttonSecondaryHoverText: '#FFFFFF',

        navActiveText: '#282828',
        navHoverText: '#282828',

        surfaceTooltip: '#3D3D3D',
        onSurfaceTooltip: '#FFFFFF'
    }
};


// PROPOSITION 2 - Doux, moderne (bleuuuiisshh)
const ULAVAL_BLUE_THEME: ThemeTypes = {
    name: 'BLUE_THEME',
    dark: false,
    variables: {
        'border-color': '#EDEDED'
    },
    colors: {
        important: '#E30513',
        primary: '#0099FF',
        secondary: '#000000',
        info: '#41B2FF',
        success: '#51A27E',
        accent: '#BD809E',
        warning: '#F7A941',
        error: '#E30513',

        lightprimary: '#CCEBFF',
        lightsecondary: '#FFF9E5',
        lightsuccess: '#EDF6F2',
        lighterror: '#FCE5E7',
        lightwarning: '#FFF6EB',
        lightinfo: '#E5F5FF',

        textPrimary: '#3D3D3D',
        textSecondary: '#FFFFFF',
        borderColor: '#EDEDED',
        inputBorder: '#CACACA',
        containerBg: '#FFFFFF',
        background: '#F2FAFF',
        hoverColor: '#F0E9F1',
        surface: '#FFFFFF',
        'on-surface-variant': '#515151',

        grey100: '#EDEDED',
        grey200: '#DCDCDC',

        buttonHover: '#CCEBFF',
        buttonHoverText: '#004D80',
        buttonSecondaryHover: '#0099FF',
        buttonSecondaryHoverText: '#FFFFFF',

        navActiveText: '#004D80',
        navHoverText: '#004D80',

        surfaceTooltip: '#282828',
        onSurfaceTooltip: '#FFFFFF'
    }
};

// PROPOSITION 3 - accentué, assumé
const ULAVAL_PURPLE_THEME: ThemeTypes = {
    name: 'PURPLE_THEME',
    dark: false,
    variables: {
        'border-color': '#DCDCDC'
    },
    colors: {
        important: '#E30513',
        primary: '#702E78',
        secondary: '#FFC103',
        info: '#0099FF',
        success: '#51A27E',
        accent: '#F7A941',
        warning: '#FFE081',
        error: '#E30513',

        lightprimary: '#D4C0D6',
        lightsecondary: '#FFF3CC',
        lightsuccess: '#EDF6F2',
        lighterror: '#FCE5E7',
        lightwarning: '#FFF9E5',
        lightinfo: '#E5F5FF',

        textPrimary: '#282828',
        textSecondary: '#FFFFFF',
        borderColor: '#DCDCDC',
        inputBorder: '#B2B2B2',
        containerBg: '#FFFFFF',
        background: '#F2FAFF',
        hoverColor: '#F0E9F1',
        surface: '#FFFFFF',
        'on-surface-variant': '#515151',

        grey100: '#EDEDED',
        grey200: '#DCDCDC',

        buttonHover: '#D4C0D6',
        buttonHoverText: '#37173C',
        buttonSecondaryHover: '#702E78',
        buttonSecondaryHoverText: '#FFFFFF',

        navActiveText: '#37173C',
        navHoverText: '#37173C',

        surfaceTooltip: '#282828',
        onSurfaceTooltip: '#FFFFFF'
    }
};


export { ULAVAL_RED_THEME, ULAVAL_BLUE_THEME, ULAVAL_PURPLE_THEME };